<div id="payment-history-component" [ngClass]="{ 'sidebar-present': sidebarPresent }">
  <form id="paymentHistoryForm" [formGroup]="paymentHistoryForm">
    <div class="filter-date-container">
      <span
        tabindex="0"
        class="filter-date-label"
        dsContent
        [contentPath]="'shared.displayTheLast'"
      ></span>
      <div>
        <ds-form-control-container [control]="paymentHistoryForm.controls['dateRangeMonths']">
          <select
            id="paymentHistoryDateRangeMonths"
            class="icon fill"
            formControlName="dateRangeMonths"
          >
            @for (range of monthRanges; track range; let i = $index) {
              <option [value]="i">
                {{ range.text }}
              </option>
            }
          </select>
          <span class="icon-chevron-down"></span>
        </ds-form-control-container>
      </div>
    </div>
  </form>

  @if ((dataLoading$ | async) === false) {
    <div>
      @if (!!rows.length && (dataLoading$ | async) === false) {
        <ngx-datatable
          data-cy="paymentHistoryDatatable"
          #paymentHistoryTable
          class="none md-block"
          [rows]="rows"
          [columns]="columns"
          [limit]="pageLimit"
          [footerHeight]="footerHeight"
          [scrollbarH]="true"
          [ngClass]="cssClasses"
          (page)="onPageChanged()"
          [cssClasses]="{
            pagerLeftArrow: 'icon-chevron-left',
            pagerRightArrow: 'icon-chevron-right',
            pagerPrevious: 'icon-arrow-left-double',
            pagerNext: 'icon-arrow-right-double'
          }"
          [columnMode]="'force'"
          [headerHeight]="headerHeight"
          [rowHeight]="rowHeight"
        >
          <ngx-datatable-row-detail [rowHeight]="'auto'">
            <ng-template let-row="row" ngx-datatable-row-detail-template>
              <div class="pad-20">
                <div class="row">
                  <div class="column twelve">
                    @if (detailRowPayments?.length > 0) {
                      <div class="row">
                        <div class="column twelve">
                          <div class="Table">
                            <div class="Table-row Table-header">
                              <div class="Table-row-item">
                                <span
                                  dsContent
                                  [contentPath]="'billing.paymentHistory.billingAccount'"
                                ></span>
                              </div>
                              <div class="Table-row-item">
                                <span
                                  dsContent
                                  [contentPath]="'billing.paymentHistory.billingAccountNumber'"
                                ></span>
                              </div>
                              <div class="Table-row-item">
                                <span
                                  dsContent
                                  [contentPath]="'billing.paymentHistory.amount'"
                                ></span>
                              </div>
                            </div>
                            @for (payment of detailRowPayments; track payment) {
                              <div class="Table-row">
                                <div class="Table-row-item" data-header="Billing Account">
                                  {{ payment.nickName }}
                                </div>
                                <div class="Table-row-item" data-header="Billing Account Number">
                                  {{ payment.billAccountNumber | prettyBillingAcctNum }}
                                </div>
                                <div
                                  class="Table-row-item"
                                  data-cy="paymentHistoryExpandedPaymentAmountCell"
                                  data-header="Amount"
                                >
                                  {{
                                    payment.billAcctPaymentAmount
                                      | currency: 'USD' : 'symbol' : '1.2-2'
                                  }}
                                </div>
                              </div>
                            }
                            <hr aria-hidden="true" class="dashed" />
                          </div>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </ng-template>
          </ngx-datatable-row-detail>
        </ngx-datatable>
      }
      <ds-table
        class="block md-none"
        [ngClass]="{ 'mobile-only': sidebarPresent }"
        [rows]="rows"
        [columns]="columns"
        [headerHeight]="60"
        [rowDetail]="paymentDetailMobile"
      >
        <ng-template let-row="row" #paymentDetailMobile>
          <div class="payment-detail-row">
            <div class="row">
              <div class="column twelve">
                @if (detailRowPayments?.length > 0) {
                  <div class="pad-20 row">
                    <div class="column twelve">
                      <div class="Table">
                        <div class="Table-row Table-header">
                          <div class="Table-row-item">
                            <span
                              dsContent
                              [contentPath]="'billing.paymentHistory.billingAccount'"
                            ></span>
                          </div>
                          <div class="Table-row-item">
                            <span
                              dsContent
                              [contentPath]="'billing.paymentHistory.billingAccountNumber'"
                            ></span>
                          </div>
                          <div class="Table-row-item">
                            <span dsContent [contentPath]="'billing.paymentHistory.amount'"></span>
                          </div>
                        </div>
                        @for (payment of detailRowPayments; track payment) {
                          <div class="Table-row">
                            <div class="Table-row-item" data-header="Billing Account">
                              {{ payment.nickName }}
                            </div>
                            <div class="Table-row-item" data-header="Billing Account Number">
                              {{ payment.billAccountNumber | prettyBillingAcctNum }}
                            </div>
                            <div class="Table-row-item" data-header="Amount">
                              {{
                                payment.billAcctPaymentAmount | currency: 'USD' : 'symbol' : '1.2-2'
                              }}
                            </div>
                          </div>
                        }
                        <hr aria-hidden="true" class="dashed" />
                      </div>
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
        </ng-template>
      </ds-table>
      <div class="pad-vertical-20">
        @if (!rows.length && (hasError$ | async) === false) {
          <p dsContent [contentPath]="'billing.noPaymentHistory'"></p>
        }
        @if (!rows.length && (hasError$ | async)) {
          <p dsContent [contentPath]="'billing.noPaymentHistoryApiError'"></p>
        }
        @if (!!rows.length && isContactBillingToggleEnabled === true) {
          <p>
            <span
              dsContent
              [contentPath]="'billing.paymentHistoryRequestMorePre'"
              [applicationDependentCopy]="true"
            ></span>
            <a
              href="javascript:void(0);"
              [dsRouterLink]="[billingPaths.BILLING_CONTACT, 'paymentHistory']"
            >
              <span
                dsContent
                [contentPath]="'billing.paymentHistoryRequestMoreLink'"
                [applicationDependentCopy]="true"
              ></span>
            </a>
            <span
              dsContent
              [contentPath]="'billing.paymentHistoryRequestMorePost'"
              [applicationDependentCopy]="true"
            ></span>
          </p>
        }
      </div>
    </div>
  }

  @if (dataLoading$ | async) {
    <ds-localized-spinner
      [dataLoading]="dataLoading$ | async"
      [loadingMessage]="'Looking for payment history...'"
    >
    </ds-localized-spinner>
  }
</div>

<ng-template #headerCellTpl let-column="column">
  <div class="header-cell table-header-cell-wrapper">
    <span
      [ngClass]="{
        'none lg-block': column?.name && column?.shortName,
        block: column?.name && !column?.shortName
      }"
      >{{ column?.name }}</span
    >
    @if (!!column?.shortName) {
      <span class="block lg-none">{{ column?.shortName }}</span>
    }
  </div>
</ng-template>

<ng-template #billAccountTemplate let-row="row" let-column="column" let-expanded="expanded">
  <div class="flex md-block bill-account-cell ds-table-body-cell-header-wrapper">
    <div data-cy="paymentHistoryBillingAccountCell" class="block md-none ds-table-body-cell-header">
      @if (!!row.accountReference.displayName) {
        <h3 class="primary-800-text margin-0" title="{{ row.accountReference.displayName }}">
          {{ row.accountReference.displayName }}
        </h3>
      }
      @if (!row.accountReference.displayName) {
        <h3
          class="primary-800-text margin-0"
          title="{{ row.accountReference.displayNumber | prettyBillingAcctNum }}"
        >
          {{ row.accountReference.displayNumber | prettyBillingAcctNum }}
        </h3>
      }
    </div>
    <div class="block md-none payment-detail-header" [ngClass]="{ 'mobile-only': sidebarPresent }">
      @if (
        !row.accountReference.displayNumber &&
        row.accountReference.displayName === 'Bundled Payment'
      ) {
        <div class="due-date-cell">
          <p class="margin-0 due-date-cell-date">
            @if (!togglePaymentDetails) {
              <a href="javascript:void(0);" class="no-decoration" (click)="showDetails(row)"
                ><span>View Details</span></a
              >
            }
            @if (togglePaymentDetails) {
              <a href="javascript:void(0);" class="no-decoration" (click)="hideDetails(row)"
                ><span>Hide Details</span></a
              >
            }
          </p>
        </div>
      }
    </div>
    <div class="none md-flex table-body-cell-label-content expandable-cell">
      <div>
        <span class="h3 fill">{{ row.accountReference.displayName }}</span>
        @if (
          !row.accountReference.displayNumber &&
          row.accountReference.displayName === 'Bundled Payment'
        ) {
          <div class="due-date-cell">
            <p class="margin-0 due-date-cell-date">
              @if (!expanded) {
                <a href="javascript:void(0);" class="no-decoration" (click)="showDetails(row)"
                  ><span
                    data-cy="viewDetailsBundledPaymentLink"
                    dsContent
                    [contentPath]="'policy.overview.viewDetails'"
                  ></span
                ></a>
              }
              @if (expanded) {
                <a href="javascript:void(0);" class="no-decoration" (click)="hideDetails(row)"
                  ><span dsContent [contentPath]="'policy.overview.hideDetails'"></span
                ></a>
              }
            </p>
          </div>
        }
        @if (!!row.accountReference.displayNumber && !row.accountReference.displayName) {
          <div class="due-date-cell">
            <p class="margin-0 due-date-cell-date">
              <span>{{ row.accountReference.displayNumber | prettyBillingAcctNum }}</span>
            </p>
          </div>
        }
      </div>
    </div>
  </div>
</ng-template>

<ng-template #amountTemplate let-row="row">
  <div
    data-cy="paymentHistoryPaymentAmountCell"
    class="flex md-block bill-account-cell ds-table-body-cell-header-wrapper"
  >
    <div class="block md-none ds-table-body-cell-header">
      <div class="margin-0 ng-star-inserted">
        <h3 class="amount">{{ row.paymentAmount }}</h3>
        <p class="due-date-cell-date dateClass date">{{ row.paymentDate | dateFormat }}</p>
      </div>
    </div>
  </div>
  <!-- Show span in billing overview mobile view -->
  @if (!hideForDetails) {
    <div class="due-date-cell block md-none">
      <p>{{ row.paymentAmount }}</p>
      <p class="due-date-cell-date">{{ row.paymentDate | dateFormat }}</p>
    </div>
  }
  <!--Show span in payment history Browser view -->
  <div class="due-date-cell none md-block">
    <p>{{ row.paymentAmount }}</p>
    <p class="due-date-cell-date">{{ row.paymentDate | dateFormat }}</p>
  </div>
</ng-template>

<ng-template #paymentMethodTemplate let-row="row" let-expanded="expanded">
  <div
    data-cy="paymentHistoryPaymentAccountNickNameCell"
    class="payment-method-cell table-body-cell-label-content expandable-cell"
  >
    <ds-payment-method-block
      class="cell-component"
      [rowExpanded]="expanded"
      [paymentType]="row.paymentType"
      [nickName]="row.paymentAccountNickName"
    >
    </ds-payment-method-block>
  </div>
</ng-template>

<ng-template #paymentActivityTemplate let-row="row">
  <span class="due-date-cell">
    <p class="margin-0 due-date-cell-status">{{ row.paymentStatus }}</p>
    <p class="due-date-cell-date">{{ row.paymentMethod }}</p>
  </span>
</ng-template>
